<template>
  <div style="flex: 1; padding: 20px">
    <el-row>
      <h2 style="float: left; margin-left: 15px">Production</h2>
      <br />
      <el-button style="float: right; margin-right: 30px" @click="Create()">Create MacAddress</el-button>
    </el-row>
    <br />
    <el-card>
      <el-row>
        <el-form :inline="true" :model="query" @submit.prevent.native="load" :label-position="'top'"
          class="demo-form-inline">
          <el-col>
            <el-form-item label="macAddress">
              <the-mask class="el-input__inner" v-model="query.macAddress" :masked="true" mask="FF:FF:FF:FF:FF:FF"
                @input="sanitize($event)" @keyup.enter.native="load" :tokens="hexTokens" />
            </el-form-item>
          </el-col>
        </el-form>

        <el-col>
          <el-button type="primary" @click="
  query.page = 1;
load();
            ">Filter</el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" style="text-align: right">
          <el-pagination layout="prev, pager, next,sizes" :total="searchResult.total" :page-sizes="pageSizes"
            :page-size.sync="query.pageSize" :current-page.sync="query.page" @current-change="load"
            @size-change="load"></el-pagination>
          <!-- Table -->
        </el-col>
        <el-col>
          <el-table v-loading="loading" :data="searchResult.productions" class="border">
            <el-table-column type="index" width="50" />
            <el-table-column prop="name" label="Name" />
            <el-table-column prop="createdAt" label="Create At" />
            <el-table-column prop="updateAt" label="update At" />
            <el-table-column prop="totalHardwares" label="Total Hardware" width="150px;" />
            <el-table-column prop="statu" label="Statu" width="150px;" />
            <el-table-column label="Actions" width="200px">
              <template slot-scope="scope">
                <el-button size="mini" icon="el-icon-view" @click="seeOverAll(scope.row)"></el-button>
                <el-dropdown style="margin-left: 12px" @command="handleCommand" v-if="
  !(
    scope.row.statu == 'COMPLETED' ||
    scope.row.statu == 'CANCELLED'
  )
">
                  <span class="el-dropdown-link">
                    Options<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="{ scope: scope.row, event: 'EDIT' }">Edit</el-dropdown-item>
                    <el-dropdown-item :command="{ scope: scope.row, event: 'COMPLETED' }">COMPLETED</el-dropdown-item>
                    <el-dropdown-item :command="{ scope: scope.row, event: 'CANCELLED' }">CANCELLED</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </el-table>
        </el-col>

        <el-col :span="24" style="text-align: right">
          <el-pagination layout="prev, pager, next,sizes" :total="searchResult.total" :page-sizes="pageSizes"
            :page-size.sync="query.pageSize" :current-page.sync="query.page" @current-change="load"
            @size-change="load"></el-pagination>
          <!-- Table -->
        </el-col>
      </el-row>
    </el-card>
    <el-dialog width="70%" title="Create MacAddress" :visible.sync="showForm">
      <el-form ref="form" :model="form" v-loading="formLoading" label-width="150px">
        <el-row>
          <el-col>
            <el-row>
              <el-col>
                <el-form-item label="Name" prop="name">
                  <el-input placeholder="Please input" v-model="name"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-form-item label="senseway lora lite" prop="senseway_lora_lite">
                  <el-input :disabled="!!hardwareTable.length" placeholder="Please input"
                    v-model="form.senseway_lora_lite"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="senseway ble lite" prop="senseway_ble_lite">
                  <el-input :disabled="!!hardwareTable.length" placeholder="Please input"
                    v-model="form.senseway_ble_lite"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="trigger" prop="trigger">
                  <el-input :disabled="!!hardwareTable.length" placeholder="Please input"
                    v-model="form.trigger"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="senseway wired lite" prop="senseway_wired_lite">
                  <el-input :disabled="!!hardwareTable.length" placeholder="Please input"
                    v-model="form.senseway_wired_lite"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-form-item label="senseway" prop="senseway">
                  <el-input :disabled="!!hardwareTable.length" placeholder="Please input"
                    v-model="form.senseway"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="infinity" prop="infinity">
                  <el-input :disabled="!!hardwareTable.length" placeholder="Please input"
                    v-model="form.infinity"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="wired" prop="wired">
                  <el-input :disabled="!!hardwareTable.length" placeholder="Please input"
                    v-model="form.wired"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="wired pro" prop="wired_pro">
                  <el-input :disabled="!!hardwareTable.length" placeholder="Please input"
                    v-model="form.wired_pro"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-form-item label="anchor displacement" prop="anchor_displacement">
                  <el-input :disabled="!!hardwareTable.length" placeholder="Please input"
                    v-model="form.anchor_displacement"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="ads1115" prop="ads1115">
                  <el-input :disabled="!!hardwareTable.length" placeholder="Please input"
                    v-model="form.ads1115"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="anchor" prop="anchor">
                  <el-input :disabled="!!hardwareTable.length" placeholder="Please input"
                    v-model="form.anchor"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="arke lora" prop="arke_lora">
                  <el-input :disabled="!!hardwareTable.length" placeholder="Please input"
                    v-model="form.arke_lora"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="Generated Mac." prop="anchor">
                  {{ hardwareTable.length }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item>
              <el-table v-loading="loading" :data="hardwareTable" class="border" :height="400">
                <el-table-column type="index" width="50" />
                <el-table-column prop="macAddress" label="macAddress" />
                <el-table-column prop="type" label="Product Type" />
              </el-table>
            </el-form-item>
            <el-form-item>
              <el-button :disabled="!hardwareTable.length" type="primary" @click="CreateProduction()">Create</el-button>
              <el-button :disabled="!!hardwareTable.length" type="primary" @click="generateMacAddresses()">Generate
                Mac</el-button>
              <el-button @click="hardwareTable = []">Cancel Mac</el-button>
              <el-button @click="Cancel()">Cancel</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
    <el-dialog width="80%" title="Edit Production" :visible.sync="editShowform">
      <el-form ref="form" :model="form" v-loading="formLoading" label-width="150px">
        <el-row>
          <el-col>
            <el-row>
              <el-col>
                <el-form-item label="Name" prop="name">
                  <el-input :disabled="seeAll" placeholder="Please input" v-model="name"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4">
                <el-form-item label="senseway lora lite" prop="senseway_lora_lite">
                  {{ form.senseway_lora_lite }}
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="senseway ble lite" prop="senseway_ble_lite">
                  {{ form.senseway_ble_lite }}
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="trigger" prop="trigger">
                  {{ form.trigger }}
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="senseway wired lite" prop="senseway_wired_lite">
                  {{ form.senseway_wired_lite }}
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="senseway" prop="senseway">
                  {{ form.senseway }}
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="infinity" prop="infinity">
                  {{ form.infinity }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4">
                <el-form-item label="wired" prop="wired">
                  {{ form.wired }}
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="wired pro" prop="wired_pro">
                  {{ form.wired_pro }}
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="arke lora" prop="arke_lora">
                  {{ form.arke_lora }}
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="anchor displacement" prop="anchor_displacement">
                  {{ form.anchor_displacement }}
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="ads1115" prop="ads1115">
                  {{ form.ads1115 }}
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="anchor" prop="anchor">
                  {{ form.anchor }}
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="Generated Mac." prop="anchor">
                  {{ hardwareTable.length }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <h4>All MacAddress</h4>
                <el-form style="item-align: center" label-position="top" :model="category" label-width="150px">
                  <el-col :span="2">
                    <el-form-item label="makeCase">
                      <el-checkbox @change="checkCategoryChange('makeCase')" v-model="category.makeCase.checked"
                        :indeterminate="category.makeCase.indeterminate"></el-checkbox>
                    </el-form-item>
                  </el-col>
                  <el-col :span="2">
                    <el-form-item label="sticker">
                      <el-checkbox @change="checkCategoryChange('sticker')" v-model="category.sticker.checked"
                        :indeterminate="category.sticker.indeterminate"></el-checkbox>
                    </el-form-item>
                  </el-col>
                  <el-col :span="3">
                    <el-form-item label="ledAndSmoke">
                      <el-checkbox @change="checkCategoryChange('ledAndSmoke')" v-model="category.ledAndSmoke.checked"
                        :indeterminate="category.ledAndSmoke.indeterminate"></el-checkbox>
                    </el-form-item>
                  </el-col>
                  <el-col :span="2">
                    <el-form-item label="macBurn">
                      <el-checkbox @change="checkCategoryChange('macBurn')" v-model="category.macBurn.checked"
                        :indeterminate="category.macBurn.indeterminate"></el-checkbox>
                    </el-form-item>
                  </el-col>
                  <el-col :span="2">
                    <el-form-item label="software">
                      <el-checkbox @change="checkCategoryChange('software')" v-model="category.software.checked"
                        :indeterminate="category.software.indeterminate"></el-checkbox>
                    </el-form-item>
                  </el-col>
                  <el-col :span="2">
                    <el-form-item label="test">
                      <el-checkbox @change="checkCategoryChange('test')" v-model="category.test.checked"
                        :indeterminate="category.test.indeterminate"></el-checkbox>
                    </el-form-item>
                  </el-col>
                  <el-col :span="2">
                    <el-form-item label="casing">
                      <el-checkbox @change="checkCategoryChange('casing')" v-model="category.casing.checked"
                        :indeterminate="category.casing.indeterminate"></el-checkbox>
                    </el-form-item>
                  </el-col>
                </el-form>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-table v-if="showtable" v-loading="loading" :data="hardwareTable" class="border" :height="500"
                  @selection-change="handleSelectionChange">
                  <el-table-column type="selection" width="55">
                  </el-table-column>
                  <el-table-column type="index" width="30" />
                  <el-table-column prop="macAddress" label="macAddress" />
                  <el-table-column prop="type" label="Product Type" />
                  <el-table-column prop="makeCase" label="makeCase" width="150">
                    <template slot-scope="{ row }">
                      <el-checkbox :disabled="seeAll" v-model="row.makeCase"></el-checkbox>
                    </template>
                  </el-table-column>
                  <el-table-column prop="sticker" label="sticker" width="100">
                    <template slot-scope="{ row }">
                      <el-checkbox :disabled="seeAll" v-model="row.sticker"></el-checkbox>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ledAndSmoke" label="ledAndSmoke" width="140">
                    <template slot-scope="{ row }">
                      <el-checkbox :disabled="seeAll" v-model="row.ledAndSmoke"></el-checkbox>
                    </template>
                  </el-table-column>
                  <el-table-column prop="macBurn" label="macBurn" width="100">
                    <template slot-scope="{ row }">
                      <el-checkbox :disabled="seeAll" v-model="row.macBurn"></el-checkbox>
                    </template>
                  </el-table-column>
                  <el-table-column prop="software" label="software" width="100">
                    <template slot-scope="{ row }">
                      <el-checkbox :disabled="seeAll" v-model="row.software"></el-checkbox>
                    </template>
                  </el-table-column>
                  <el-table-column prop="test" label="test" width="100">
                    <template slot-scope="{ row }">
                      <el-checkbox :disabled="seeAll" v-model="row.test"></el-checkbox>
                    </template>
                  </el-table-column>
                  <el-table-column prop="casing" label="casing" width="100">
                    <template slot-scope="{ row }">
                      <el-checkbox :disabled="seeAll" v-model="row.casing"></el-checkbox>
                    </template>
                  </el-table-column>
                  <el-table-column prop="text" label="Text">
                    <template slot-scope="{ row }">
                      <el-input :disabled="seeAll" v-model="row.text"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="Actions" width="100px">
                    <template slot-scope="scope">
                      <el-button :disabled="seeAll" size="mini" type="danger"
                        @click="deleteHardware(scope.row)">Delete</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
            <el-form-item style="margin-top: 10px">
              <el-button type="primary" @click="UpdateProduction()">Update</el-button>

              <el-button @click="Cancel()">Cancel</el-button>
              <el-button v-if="seeAll" type="info" @click="DownloadCSV()">Download MacAddress</el-button>
              <el-button type="primary" @click="SplitProduction()">Split Production</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>



<script>
import { mapState, mapActions } from "vuex";
import queryStringUtil from "query-string";
import dayjs from "dayjs";
import { TheMask } from "vue-the-mask";
export default {
  name: "Production",
  components: { TheMask },
  data() {
    return {
      hexTokens: {
        F: {
          pattern: /[0-9a-fA-F]/,
          transform: (v) => v.toLocaleUpperCase(),
        },
      },
      query: {
        macAddress: "",
        page: 1,
        pageSize: 10,
      },
      pageSizes: [10, 25, 50, 75],
      remoteMacAddress: [],
      certs: {},
      editId: "",
      editShowform: false,
      previewShowForm: false,
      customerData: "",
      showForm: false,
      formLoading: false,
      name: "",
      category: {
        makeCase: {
          checked: false,
          indeterminate: false,
        },
        sticker: {
          checked: false,
          indeterminate: false,
        },
        ledAndSmoke: {
          checked: false,
          indeterminate: false,
        },
        macBurn: {
          checked: false,
          indeterminate: false,
        },
        software: {
          checked: false,
          indeterminate: false,
        },
        test: {
          checked: false,
          indeterminate: false,
        },
        casing: {
          checked: false,
          indeterminate: false,
        },
      },
      multipleSelection: [],
      showtable: true,
      form: {
        senseway_lora_lite: 0,
        senseway_ble_lite: 0,
        trigger: 0,
        senseway_wired_lite: 0,
        senseway: 0,
        infinity: 0,
        wired: 0,
        wired_pro: 0,
        anchor: 0,
        arke_lora: 0,
        anchor_displacement: 0,
        ads1115: 0,
      },
      seeAll: false,
      hardwareTable: [],
      remoteMacAddressLoading: false,
    };
  },
  created() {
    this.getProductions(this.query);
    this.getPartners();
  },
  computed: {
    ...mapState("production", ["searchResult", "loading"]),
  },
  methods: {
    ...mapActions("production", [
      "generateMacAddress",
      "createProduction",
      "updateProduction",
      "getProductions",
      "GenerateCerts",
      "splitProduction",
    ]),
    generateCert() {
      this.$confirm(
        `Do you want to generate certification for gateways and triggers.You can generate only once. Continue?!!!`,
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(() => {
          this.hardwareTable;
          this.GenerateCerts({
            _id: this.editId,
            macAddresses: this.hardwareTable,
          }).then((res) => {
            var fileLink = document.createElement("a");
            fileLink.href = res.url;
            document.body.appendChild(fileLink);
            fileLink.click();
            fileLink.remove();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `generate certification for gateways and triggers canceled`,
          });
        });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    SplitProduction() {
      this.$confirm("Are you sure to split?", "Warning", {
        confirmButtonText: "Yes, send",
        cancelButtonText: "No",
        type: "warning",
      }).then(() => {
        this.splitProduction({
          _id: this.editId,
          newProduction: this.multipleSelection,
        }).then(() => {
          this.formLoading = false;
          this.editShowform = false;
          this.multipleSelection = [];
          this.load();
        });
      });
    },
    checkCategoryChange(type) {
      this.category[type].indeterminate = false;
      this.hardwareTable.forEach((x) => {
        x[type] = this.category[type].checked;
      });
    },
    categoryEditCheck() {
      let everyFalse;
      let everyTrue;
      for (const [key] of Object.entries(this.category)) {
        everyFalse = this.hardwareTable
          .map((x) => x[key])
          .every((x) => x == false);
        everyTrue = this.hardwareTable
          .map((x) => x[key])
          .every((x) => x == true);
        this.category[key].indeterminate = !(everyTrue || everyFalse);
        if (!this.category[key].indeterminate && everyFalse) {
          this.category[key].checked = false;
        } else if (!this.category[key].indeterminate && everyTrue) {
          this.category[key].checked = true;
        }
      }
    },
    DownloadCSV() {
      let column1 = this.hardwareTable.map((x) => x.macAddress);
      column1.unshift(`MacAddress`);

      let column2 = this.hardwareTable.map((x) => x.type);
      column2.unshift(`Type`);

      const rows = [];
      for (var i = 0; i < column1.length; i++) {
        rows.push([column1[i], column2[i]]);
      }

      let csvContent = "data:text/csv;charset=utf-8,";
      rows.forEach(function (rowArray) {
        let row = rowArray.join(",");
        csvContent += row + "\r\n";
      });
      this.triggerDownload(
        encodeURI(csvContent),
        `${this.hardwareTable.length}_Products_${dayjs().format(
          "DD/MM/YYYY HH:mm:ss"
        )}`,
        ".csv"
      );
      this.seeAll = false;
      this.editId = "";
      this.form = {
        senseway_lora_lite: 0,
        senseway_ble_lite: 0,
        trigger: 0,
        senseway_wired_lite: 0,
        senseway: 0,
        infinity: 0,
        wired: 0,
        wired_pro: 0,
        anchor: 0,
        arke_lora: 0,
        anchor_displacement: 0,
        ads1115: 0,
      };
      this.hardwareTable = [];
      this.editShowform = false;
      this.showForm = false;
    },
    triggerDownload(href, filename, ext) {
      //let self = this;
      const downloadLink = document.createElement("a");
      downloadLink.href = href;
      downloadLink.download = filename + ext;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    },
    async resizeImage(base64Str, maxWidth, maxHeight) {
      return new Promise((resolve) => {
        let img = new Image();
        img.src = base64Str;
        img.onload = () => {
          let canvas = document.createElement("canvas");
          // const MAX_WIDTH = maxWidth;
          const MAX_HEIGHT = maxHeight;
          let width = img.width;
          let height = img.height;
          width *= MAX_HEIGHT / height;
          height = MAX_HEIGHT;
          canvas.width = width;
          canvas.height = height;
          let ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, width, height);
          resolve(canvas.toDataURL());
        };
      });
    },
    handleCommand(command) {
      switch (command.event) {
        case "EDIT":
          this.Edit(command.scope);
          break;
        case "COMPLETED":
          this.$confirm(
            `Do you want to change statu to COMPLETED. Continue?!!!`,
            "Warning",
            {
              confirmButtonText: "OK",
              cancelButtonText: "Cancel",
              type: "warning",
            }
          )
            .then(() => {
              this.updateProduction({
                _id: command.scope._id,
                newStatu: "COMPLETED",
              });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: `to change statu to COMPLETED canceled`,
              });
            });
          break;
        case "CANCELLED":
          this.$confirm(
            `Do you want to change statu to CANCELLED. Continue?!!!`,
            "Warning",
            {
              confirmButtonText: "OK",
              cancelButtonText: "Cancel",
              type: "warning",
            }
          )
            .then(() => {
              this.updateProduction({
                _id: command.scope._id,
                newStatu: "CANCELLED",
              });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: `to change statu to CANCELLED canceled`,
              });
            });
          break;
      }
    },
    queryString(query) {
      var queryParams = {
        macAddress: query.macAddress,
        customer: query.customer,
        type: query.type,
      };
      return queryStringUtil.stringify(queryParams, {
        arrayFormat: "bracket",
      });
    },
    ...mapActions("partner", ["getPartners"]),
    ...mapActions("production", [
      "generateMacAddress",
      "createProduction",
      "updateProduction",
      "getProductions",
    ]),
    adviseSystemAdmin() {
      this.$message.info("advise to the system admin");
    },
    copyIdToClipboard(id) {
      this.$clipboard(id);
      this.$message.info("'" + id + "' " + "copy to clipboard success");
    },
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    generateMacAddresses() {
      this.generateMacAddress(this.form).then((data) => {
        this.hardwareTable = data.result;
      });
    },
    UpdateProduction() {
      this.formLoading = true;
      this.updateProduction({
        _id: this.editId,
        name: this.name,
        form: this.form,
        macAddresses: this.hardwareTable,
      })
        .then(() => {
          this.formLoading = false;
          this.editShowform = false;
        })
        .finally(() => {
          this.formLoading = false;
          this.load();
        });
    },
    CreateProduction() {
      if (this.hardwareTable && this.name) {
        this.formLoading = true;
        this.createProduction({
          name: this.name,
          form: this.form,
          macAddresses: this.hardwareTable,
        })
          .then(() => {
            this.formLoading = false;
            this.showForm = false;
          })
          .finally(() => {
            this.formLoading = false;
            this.load();
          });
      } else {
        this.$message({
          type: "info",
          message: "Please enter name, customer and hardwares",
        });
      }
    },
    load() {
      this.getProductions(this.query);
    },
    Create() {
      this.seeAll = false;
      this.editId = undefined;
      this.showForm = true;
      this.name = "";
      this.form = {
        senseway_lora_lite: 0,
        senseway_ble_lite: 0,
        trigger: 0,
        senseway_wired_lite: 0,
        senseway: 0,
        infinity: 0,
        wired: 0,
        wired_pro: 0,
        anchor: 0,
        arke_lora: 0,
        anchor_displacement: 0,
        ads1115: 0,
      };
      this.hardwareTable = [];
    },
    Cancel() {
      this.seeAll = false;
      this.editId = "";
      this.name = "";
      this.form = {
        senseway_lora_lite: 0,
        senseway_ble_lite: 0,
        trigger: 0,
        senseway_wired_lite: 0,
        senseway: 0,
        infinity: 0,
        wired: 0,
        wired_pro: 0,
        anchor: 0,
        arke_lora: 0,
        anchor_displacement: 0,
        ads1115: 0,
      };
      this.hardwareTable = [];
      this.editShowform = false;
      this.showForm = false;
      this.load();
    },
    seeOverAll(scope) {
      (this.name = scope.name),
        (this.form = {
          senseway_lora_lite: scope.hardwares.senseway_lora_lite,
          senseway_ble_lite: scope.hardwares.senseway_ble_lite,
          trigger: scope.hardwares.trigger,
          senseway_wired_lite: scope.hardwares.senseway_wired_lite,
          senseway: scope.hardwares.senseway,
          infinity: scope.hardwares.infinity,
          wired: scope.hardwares.wired,
          wired_pro: scope.hardwares.wired_pro,
          anchor: scope.hardwares.anchor,
          arke_lora: scope.hardwares.arke_lora,
          anchor_displacement: scope.hardwares.anchor_displacement,
          ads1115: scope.hardwares.ads1115,
        });
      this.seeAll = true;
      this.hardwareTable = scope.hardwares.macAddress;
      this.editId = scope._id;
      this.editShowform = true;
    },
    deleteHardware(scope) {
      this.$confirm(
        "This will permanently delete the MacAddress. Continue? If continue, please click update.",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(() => {
          let index = this.hardwareTable.findIndex(
            (x) => x.macAddress == scope.macAddress
          );
          this.hardwareTable.splice(index, 1);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled",
          });
        });
    },
    Edit(scope) {
      this.seeAll = false;
      this.name = scope.name;
      this.form = {
        senseway_lora_lite: scope.hardwares.senseway_lora_lite,
        senseway_ble_lite: scope.hardwares.senseway_ble_lite,
        trigger: scope.hardwares.trigger,
        senseway_wired_lite: scope.hardwares.senseway_wired_lite,
        senseway: scope.hardwares.senseway,
        infinity: scope.hardwares.infinity,
        wired: scope.hardwares.wired,
        wired_pro: scope.hardwares.wired_pro,
        anchor: scope.hardwares.anchor,
        arke_lora: scope.hardwares.arke_lora,
        anchor_displacement: scope.hardwares.anchor_displacement,
        ads1115: scope.hardwares.ads1115,
      };
      this.hardwareTable = scope.hardwares.macAddress;
      this.editId = scope._id;
      this.editShowform = true;
    },
    goBack() {
      this.$router.go(-1);
    },
  },
  watch: {
    editShowform() {
      if (this.editShowform) {
        this.categoryEditCheck();
      }
    },
  },
};
</script>
<style scoped>
abbr {
  max-width: 150px;
  word-break: initial;
}

.container {
  padding: 20px;
  margin-top: 0px;
  flex: 1;
  display: flex;
}

.tree-container {
  flex-basis: 20%;
  border: 1.5px solid #e4e7ed;
  margin-right: 10px;
}

.tabs {
  flex-basis: 80%;
  display: flex;
}
</style>